import React from 'react';
import styled, { keyframes } from 'styled-components';

// Define the fade-in animation
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

// Style for animated words
const AnimatedSpan = styled.span`
  display: inline;
  animation: ${fadeIn} 0.5s ease-in-out;
  animation-fill-mode: both;
`;

// Custom component to split text into words with animations
const AnimatedText = ({ children }: { children: React.ReactNode }) => {
  if (typeof children !== 'string') {
    return children;
  }

  // Split content into words and preserve spaces/formatting
  const parts = children.split(/(\s+)/).map((word, i) => {
    // Skip animating spaces/newlines but preserve them
    if (word.trim() === '') {
      return word;
    }

    // Create an animated span for each actual word
    return (
      <AnimatedSpan key={`word-${word.slice(0, 3)}-${i}`}>{word}</AnimatedSpan>
    );
  });

  return parts;
};

// Generic component to animate any HTML element
const AnimatedElement = ({
  node,
  children,
}: {
  node?: { tagName?: string };
  children?: React.ReactNode;
}) => {
  const TagName = node?.tagName as keyof JSX.IntrinsicElements;

  return (
    <TagName dir="auto">
      <AnimatedText>{children}</AnimatedText>
    </TagName>
  );
};

export default AnimatedElement;
